import { defineStaticListFilter } from '../engine/descriptor';
import { FilterId, FilterType } from '../types/filters';

export const OVERALL_RATING_OPTIONS = [
  { value: '1', label: '1' },
  { value: '2', label: '2' },
  { value: '3', label: '3' },
  { value: '4', label: '4' },
  { value: '5', label: '5' },
];

export const overallRatingDescriptor = defineStaticListFilter({
  definition: {
    id: FilterId.OVERALL_RATING,
    name: 'Overall Rating',
    selections: [],
    type: FilterType.STATIC_LIST,
    isVisible: true,
  },
});
